import type { ComponentPublicInstance } from 'vue'

/**
 * Success state for request forms that replace themselves with a success alert.
 *
 * The submitted form is swapped for a much shorter alert, so the alert can end up
 * above the current scroll position and stay unnoticed. Bind `formBlock` to the
 * block wrapping the form to scroll it back into view once the alert is rendered.
 * Header offset comes from the `.FormScrollOffset` class on that block.
 */
export const useFormRequestSuccess = () => {
  const alert = ref(false)
  const requestId = ref('')
  const formBlock = ref<ComponentPublicInstance | null>(null)

  const handleSuccessSubmit = async (id: string) => {
    requestId.value = id
    alert.value = true

    await nextTick()
    formBlock.value?.$el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  return { alert, requestId, formBlock, handleSuccessSubmit }
}
